function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "letme",
  d: "M93.4861 24.6187C95.4167 24.6187 96.9459 25.1921 98.0737 26.339C99.2205 27.4667 99.794 29.1679 99.794 31.4426V40.2735H95.3211V32.1307C95.3211 30.9074 95.0631 29.9994 94.547 29.4069C94.05 28.7952 93.3332 28.4894 92.3966 28.4894C91.3453 28.4894 90.5138 28.8334 89.9022 29.5215C89.2905 30.1906 88.9847 31.1941 88.9847 32.5321V40.2735H84.5118V32.1307C84.5118 29.7031 83.537 28.4894 81.5873 28.4894C80.5551 28.4894 79.7332 28.8334 79.1215 29.5215C78.5099 30.1906 78.204 31.1941 78.204 32.5321V40.2735H73.7312V24.848H78.0033V26.6257C78.5768 25.9758 79.2744 25.4788 80.0964 25.1347C80.9374 24.7907 81.8549 24.6187 82.8489 24.6187C83.9384 24.6187 84.9228 24.8385 85.8021 25.2781C86.6813 25.6986 87.3886 26.3199 87.9238 27.1418C88.5546 26.339 89.3478 25.7177 90.3036 25.2781C91.2784 24.8385 92.3393 24.6187 93.4861 24.6187Z",
  fill: "#29292E"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "letme",
  d: "M117.934 32.6181C117.934 32.6755 117.906 33.0769 117.848 33.8223H106.179C106.389 34.7781 106.886 35.5331 107.67 36.0874C108.453 36.6417 109.428 36.9189 110.594 36.9189C111.397 36.9189 112.104 36.8042 112.716 36.5748C113.347 36.3263 113.93 35.9441 114.465 35.428L116.845 38.0084C115.392 39.6714 113.27 40.5029 110.48 40.5029C108.74 40.5029 107.201 40.1684 105.863 39.4994C104.525 38.8112 103.493 37.8651 102.767 36.6609C102.041 35.4566 101.677 34.0899 101.677 32.5608C101.677 31.0507 102.031 29.6936 102.738 28.4894C103.465 27.266 104.449 26.3199 105.691 25.6508C106.953 24.9627 108.358 24.6187 109.906 24.6187C111.416 24.6187 112.783 24.9436 114.006 25.5935C115.23 26.2434 116.185 27.18 116.873 28.4033C117.581 29.6076 117.934 31.0125 117.934 32.6181ZM109.935 28.0019C108.922 28.0019 108.071 28.2887 107.383 28.8621C106.695 29.4355 106.274 30.2192 106.121 31.2132H113.72C113.567 30.2383 113.146 29.4642 112.458 28.8908C111.77 28.2982 110.929 28.0019 109.935 28.0019Z",
  fill: "#29292E"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M33.0861 24.848L30.0182 40.2735H25.7747L26.0615 38.7539C24.7808 39.9199 23.2038 40.5029 21.3306 40.5029C20.1264 40.5029 19.0177 40.2257 18.0047 39.6714C16.9916 39.1171 16.1792 38.3238 15.5675 37.2916C14.975 36.2403 14.6787 35.0074 14.6787 33.593C14.6787 31.8918 15.0514 30.3626 15.7969 29.0055C16.5615 27.6292 17.5937 26.5588 18.8935 25.7942C20.1933 25.0105 21.6269 24.6187 23.1943 24.6187C25.5645 24.6187 27.237 25.3928 28.2119 26.9411L28.6133 24.848H33.0861ZM22.7068 36.8042C23.5861 36.8042 24.3698 36.594 25.0579 36.1734C25.7461 35.7338 26.2813 35.1317 26.6636 34.3671C27.0459 33.6025 27.237 32.7233 27.237 31.7293C27.237 30.678 26.9216 29.8465 26.2908 29.2348C25.6792 28.6232 24.819 28.3173 23.7104 28.3173C22.8311 28.3173 22.0474 28.5372 21.3593 28.9768C20.6711 29.3973 20.1359 29.9899 19.7536 30.7544C19.3713 31.519 19.1802 32.3983 19.1802 33.3923C19.1802 34.4436 19.486 35.2751 20.0977 35.8867C20.7285 36.4984 21.5982 36.8042 22.7068 36.8042Z",
  fill: "url(#paint0_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M38.6321 40.5029C37.2941 40.5029 36.0229 40.3595 34.8187 40.0728C33.6336 39.767 32.7065 39.3751 32.0375 38.8973L33.7579 35.6573C34.4269 36.097 35.2392 36.4506 36.195 36.7182C37.1698 36.9858 38.1447 37.1196 39.1195 37.1196C40.1326 37.1196 40.8876 36.9954 41.3846 36.7469C41.8816 36.4793 42.13 36.1065 42.13 35.6287C42.13 35.2464 41.9102 34.9692 41.4706 34.7972C41.031 34.6252 40.3237 34.4436 39.3489 34.2524C38.2402 34.0422 37.3227 33.8128 36.5964 33.5643C35.8891 33.3158 35.2679 32.9144 34.7327 32.3601C34.2166 31.7866 33.9586 31.0125 33.9586 30.0376C33.9586 28.3364 34.6658 27.008 36.0803 26.0523C37.5139 25.0965 39.3871 24.6187 41.7 24.6187C42.7704 24.6187 43.8121 24.7333 44.8252 24.9627C45.8383 25.1921 46.6984 25.5075 47.4057 25.9089L45.8001 29.1775C44.5385 28.3938 43.0189 28.0019 41.2412 28.0019C40.2664 28.0019 39.5209 28.1453 39.0048 28.432C38.5078 28.7187 38.2593 29.0819 38.2593 29.5216C38.2593 29.923 38.4792 30.2192 38.9188 30.4104C39.3584 30.5824 40.0943 30.7736 41.1265 30.9838C42.2161 31.1941 43.1049 31.4235 43.793 31.6719C44.5003 31.9013 45.1119 32.2932 45.628 32.8475C46.1441 33.4018 46.4022 34.1568 46.4022 35.1126C46.4022 36.8329 45.6758 38.1614 44.2231 39.098C42.7895 40.0346 40.9258 40.5029 38.6321 40.5029Z",
  fill: "url(#paint1_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M58.5949 31.5573L63.8992 40.2735H58.7096L55.0396 34.2811L52.3157 36.5462L51.5703 40.2735H47.0975L51.3409 18.999H55.8137L53.434 30.8978L60.8313 24.848H66.6517L58.5949 31.5573Z",
  fill: "url(#paint2_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M76 15.9024V8.73438C76 5.56737 73.4327 3 70.2659 3H8.62412C5.45725 3 2.89 5.56737 2.89 8.73438V48.8751C2.89 52.0421 5.45725 54.6094 8.62412 54.6094H18.6588L15.3052 70.2603C15.0121 71.6283 16.6513 72.563 17.6793 71.6141L32.9941 57.4766H70.2659C73.4327 57.4766 76 54.9093 76 51.7423V48.8751",
  stroke: "url(#paint3_linear)",
  strokeWidth: 4.30079
});

var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 14.6787,
  y1: 18.999,
  x2: 26.7578,
  y2: 53.1105,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4CFF48"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#039F00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 14.6787,
  y1: 18.999,
  x2: 26.7578,
  y2: 53.1105,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4CFF48"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#039F00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 14.6787,
  y1: 18.999,
  x2: 26.7578,
  y2: 53.1105,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4CFF48"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#039F00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 76,
  y1: 3,
  x2: 15.7884,
  y2: 77.5443,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD748"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#039F00"
})));

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 75,
    viewBox: "0 0 122 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8774bdc1.svg";
export { ForwardRef as ReactComponent };